import axios from 'axios';

import _auth from './authUtil';
const _axios = axios.create({
	// baseURL: 'http://localhost:81/', // LOCAL
	baseURL: 'https://www.bridge.strategio.cloud/', // LOCAL
	timeout: 30000
	// headers: {'Content-Type': 'application/x-www-form-urlencoded'}
})

_axios.interceptors.request.use((config) => {
	let volatileToken = _auth.getSessionToken();
	console.log(volatileToken);
	if(volatileToken === "" || volatileToken === undefined || volatileToken === null) {
		return config;
	} else {
		config.headers.Authorization = 'Bearer ' + (volatileToken || '');
		return config;
	}
});
_axios.interceptors.response.use((response) => {
	return response;
}, (error) => {
	if(error.response) {
		if(error.response.status === 401) {
			console.warn(error);
			_auth.destroySessionToken();
			window.location.hash= "/";
		}	
	} else {
		// Something happened in setting up the request that triggered an Error
		console.log('Error', error.message);
	}
	return Promise.reject(error);
});

export default _axios;



// WEBPACK FOOTER //
// ./src/utils/axiosWrapper.js